import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-attachment',
  templateUrl: './edit-attachment.component.html',
  styleUrls: ['./edit-attachment.component.sass']
})
export class EditAttachmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
